import { errorToString } from "@/error/errorUnwrapper";
import { piserverAPIUrl } from "@/utils/env/Environment";
import { isUnknownRecord } from "@/utils/type";

export function settledToString(result: PromiseSettledResult<string>) {
  return result.status === "fulfilled"
    ? result.value
    : "promise failed: " + errorToString(result.reason, "unknown reason");
}

export async function assertResolve(call: () => Promise<unknown>) {
  try {
    return (await call()) ? "ok" : "empty response";
  } catch (e) {
    return errorToString(e, "unknown");
  }
}

export async function assertServerInfo(call: () => Promise<unknown>) {
  try {
    const value = await call();
    if (!isUnknownRecord(value)) {
      return String(value);
    }
    return value.major_API_version ? "ok" : JSON.stringify(value);
  } catch (e) {
    return errorToString(e, "unknown");
  }
}

export function loadImage(url: string, timeout: number) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const timer = window.setTimeout(() => {
      img.src = "";
      reject(Error("timeout"));
    }, timeout);
    img.onload = () => {
      window.clearTimeout(timer);
      resolve(img);
    };
    img.onerror = (e) => {
      window.clearTimeout(timer);
      reject(Error(typeof e === "string" ? e : e.type));
    };
    const random = Math.floor((1 + Math.random()) * 0x10000).toString(16);
    // add a random query parameter to avoid caching
    img.src = `${url}?no-cache=${random}`;
  });
}

export async function callBackend(url: string, timeout: number) {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(`${piserverAPIUrl}/${url}`, {
      credentials: "include",
      signal: controller.signal,
    });
    const data = await res.json();
    return data?.response;
  } finally {
    window.clearTimeout(timer);
  }
}
